<template>
  <div class="pb-5">
    <h2>Financeiro</h2>

    <hr>

    <div class="col-12 text-center">
      <img height="50" :src="profile.custom_logo_url" class="mb-3">
      <h5>{{ profile.name }}</h5>
      <p><b>{{ profile.id }}</b></p>
    </div>

    <hr class="w-100">

    <div class="col-12 d-flex justify-content-center">
      <p class="badge badge-pill" :class=" profile['is_verified?'] ? 'badge-success':'badge-danger' ">
        <strong>{{ profile['is_verified?'] ? "VERIFICADA":"NÃO VERIFICADA"}}</strong>
      </p>
      <p class="badge badge-pill" :class=" profile['can_receive?'] ? 'badge-success':'badge-danger' ">
        <strong>{{ profile['can_receive?'] ? "PODE RECEBER":"NÃO PODE RECEBER"}}</strong>
      </p>
      <p class="badge badge-pill" :class=" profile.credit_card_verified ? 'badge-success':'badge-danger' ">
        <strong>{{ profile.credit_card_verified ? "CARTÃO CREDITO VERIFICADO":"CARTÃO CREDITO NÃO VERIFICADO"}}</strong>
      </p>
    </div>

    <hr class="w-100">

    <div class="row">
      <div class="col-12 col-sm-6 col-md-3 text-center">
        <p><b><small>Saldo</small></b></p>
        <h1>{{ profile.balance }}</h1>
      </div>

      <div class="col-12 col-sm-6 col-md-3 text-center">
        <p><b><small>Disponivel para saque</small></b></p>
        <h1>{{ profile.balance_available_for_withdraw }}</h1>
      </div>

      <div class="col-12 col-sm-6 col-md-3 text-center">
        <p><b><small>Saldo protegido</small></b></p>
        <h1>{{ profile.protected_balance }}</h1>
      </div>

      <div class="col-12 col-sm-6 col-md-3 text-center">
        <p><b><small>Saldo recebido</small></b></p>
        <h1>{{ profile.receivable_balance }}</h1>
      </div>
    </div>

    <hr class="w-100">

    <div class="row">
      <div class="col-12 col-sm-4 text-center">
        <p><b><small>Vendas mês passado</small></b></p>
        <h1>{{ profile.volume_last_month }}</h1>
      </div>

      <div class="col-12 col-sm-4 text-center">
        <p><b><small>Vendas este mês</small></b></p>
        <h1>{{ profile.volume_this_month }}</h1>
      </div>

      <div class="col-12 col-sm-4 text-center">
        <p><b><small>Comissão</small></b></p>
        <h1>{{ profile.commissions.percent }}%</h1>
      </div>
    </div>

    <hr class="w-100">

    <div class="col-12 row bg-light p-4 border rounded">
      <h3 class="col-12">Último saque</h3>
      <p class="col-12 col-md-8">ID: <b>{{ profile.last_withdraw.id  }}</b></p>
      <p class="col-12 col-md-4">Valor: <b>{{ profile.last_withdraw.amount | formatMoney }}</b></p>
      <p class="col-12 col-md-4">Banco: <b>{{ profile.last_withdraw.bank }}</b></p>
      <p class="col-12 col-md-4">Agencia: <b>{{ profile.last_withdraw.bank_ag }}</b></p>
      <p class="col-12 col-md-4">Conta: <b>{{ profile.last_withdraw.bank_cc }}</b></p>
      <p class="col-12">Data: <b>{{ profile.last_withdraw.created_at }}</b></p>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  data () {
    return {
      profile: {}
    }
  },
  methods: {
    loadProfile: function () {
      Axios.get('/teacher/profile')
        .then(res => {
          this.profile = res.data;
        })
        .catch(err => console.error(err))
    }
  },
  created() {
    this.loadProfile()
  }
}
</script>

<style>

</style>
